const ProtocolType = {
  COMPLAINT: "complaint",
  QAS: "qas",
  DSAR: "dsar",
  LEGACY: "legacy",
  PROPOSAL: "proposal",
  OMBUDSMAN: "ombudsman",
  NR1: "nr1",
  SUPPORT: "support",
  GIFTS_HOSPITALITY: "gifts-hospitality",
};

export default ProtocolType;
